/**
 * Japan direct login URLs use /login. Rewrite to the home page and keep the query.
 */
export default function rewriteLoginPath() {
  if (window.location.pathname !== "/login") return;

  window.history.replaceState(
    window.history.state,
    "",
    `/${window.location.search}`,
  );
}
